import { styled } from 'stitches.config'

export const FreezeDriedRawNuggetsRoot = styled('div', {
})

export const BreadCrumbWrapper = styled('div', {
  background: '$accent-white',
  padding: '$2 $3',
  display: 'block',

  '@bp2': {
    padding: '$2 $6',
    display: 'none',
  },
})
